import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginRedirect = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-6 pt-6 border-t border-border text-center">
      <p className="text-text-secondary mb-3">
        Уже есть аккаунт?
      </p>
      <Button
        variant="outline"
        size="default"
        fullWidth
        iconName="LogIn"
        iconPosition="left"
        onClick={() => navigate('/login')}
      >
        Войти в систему
      </Button>
    </div>
  );
};

export default LoginRedirect;